<div class="d-flex justify-content-center align-items-center py-10">
  <div class="spinner-border text-primary mb-1" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
